import { Component } from '@angular/core';

@Component({
  selector: 'app-server-500',
  templateUrl: './server-500.component.html',
  styleUrl: './server-500.component.css'
})
export class Server500Component {

}
